export const MY_PATIENTS_STATE_NAME = 'root.worklist_mypatients';
export const MY_PATIENTS_PAGE_TITLE = 'My Patients';
export const MY_PATIENTS_URL = '/worklist/mypatients';
export const MY_PATIENTS_TEMPLATE_URL = 'views/templates/worklistTabTemplate.html';
export const MY_PATIENTS_CONTROLLER = 'WorklistCtrl';
export const MY_PATIENTS_ENABLE_SEARCH_BUTTON = false;
export const MY_PATIENTS_ENABLE_FILTER_BUTTON = false;
export const MY_PATIENTS_SHOULD_SHOW_TAGS = false;
export const MY_PATIENTS_ENABLE_OUTSIDE_STUDIES_OPTION = false;
export const MY_PATIENTS_ENABLE_LINK_EXAMS_OPTION = false;
export const MY_PATIENTS_IS_MY_PATIENTS = true;


// WEBPACK FOOTER //
// ./src/scripts/constants/state-constants.js